import { Trans, useTranslation } from 'react-i18next'

import { AlertDropDown, Button, Divider, Text } from '@reveni-io/reveni-ui'

import { availableGroupActions } from '@/hooks/useReturnGroup/constants'

import * as Styles from './styles'

const ReturnGroupIn = ({ returnGroup, onJoinReturnGroup, availableGroupAction }) => {
  const { t, i18n } = useTranslation()

  if (!returnGroup || availableGroupAction !== availableGroupActions.in) return null

  const getFormattedOrderNames = () => {
    const listFormat = new Intl.ListFormat(i18n.language, { style: 'long', type: 'conjunction' })
    return listFormat.format(returnGroup.order_names)
  }

  return (
    <>
      <Divider />
      <Styles.Container>
        <AlertDropDown options={{ withoutDropDown: true }} title={t('¿Deseas combinar tus devoluciones?')}>
          <Styles.InfoContainer>
            <Text type="bodySRegular">
              <Trans i18nKey="returnGroupInput" values={{ orderNames: getFormattedOrderNames() }}>
                Si lo deseas, puedes devolver los productos seleccionados junto con tu devolución del pedido{' '}
                <strong>
                  {getFormattedOrderNames()}, en una sola caja, utilizando la misma etiqueta de devolución.
                </strong>
              </Trans>
            </Text>
            <Styles.ActionContainer>
              <Text type="bodySRegular">
                {t(
                  'Hacer una devolución combinada te ahorra el coste de obtener una etiqueta de devolución para este pedido.'
                )}
              </Text>
              <Button onClick={onJoinReturnGroup}>{t('Quiero combinar mi devolución')}</Button>
            </Styles.ActionContainer>
          </Styles.InfoContainer>
        </AlertDropDown>
      </Styles.Container>
    </>
  )
}

export default ReturnGroupIn
